import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b16a84c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value"]
const _hoisted_2 = ["for"]

import {computed, ref, Ref, onMounted} from 'vue'
    import AttributeButton from '../UI/AttributeButton.vue';
    import type {ProductDops } from './types'

    interface IProps {
        dops:Array<ProductDops>
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'DopsSection',
  props: {
    dops: {}
  },
  emits: ['selectedDop'],
  setup(__props: any, { emit }) {

const props = __props;

    

    let selectedDops = ref([])

    
    emit('selectedDop', selectedDops)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dops, (dop, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "attr-values",
        key: i
      }, [
        _withDirectives(_createElementVNode("input", {
          id: dop.id.toString() + 'd',
          name: 'dopping',
          type: "checkbox",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          value: dop.id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedDops) ? (selectedDops).value = $event : selectedDops = $event))
        }, null, 8, _hoisted_1), [
          [_vModelCheckbox, _unref(selectedDops)]
        ]),
        _createElementVNode("label", {
          id: "btn-click",
          class: "menu-button-container",
          for: dop.id.toString() + 'd'
        }, [
          _createElementVNode("span", null, _toDisplayString(dop.dopping), 1)
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})